import { render, staticRenderFns } from "./myClassifiedsCriteria.vue?vue&type=template&id=147ff92e&"
import script from "./myClassifiedsCriteria.vue?vue&type=script&lang=ts&"
export * from "./myClassifiedsCriteria.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports